import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
//  import { getDashboardData } from '../../ReduxStore/Slice/Pricing/ChargeBasisSlice'
import { getDashboardData } from '../../ReduxStore/Slice/Dashboard/dashboardSlice'

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import dayjs from "dayjs";
import { DatePicker, Space, theme } from 'antd';


const PricingDashboard = () => {
  const dispatch = useDispatch();
  const agent_id = localStorage.getItem("agent_id");
  const [activeTab, setActiveTab] = useState("current-month");
  const [dashboard, setDashboard] = useState([])
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [range, setRange] = useState(null);




  // Pricing Dashboard Data
  const DashboardData = async () => {
    let req = { agent_id: agent_id, filter: activeTab, link: "pricing" };
    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }
    await dispatch(getDashboardData(req)).unwrap()
      .then((response) => {
        if (response.status) {
          setDashboard(response.data)
        }
        else {
          setDashboard([])
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }

  useEffect(() => {
    DashboardData()
  }, [activeTab, range]);

  const handleTabChange = (event) => {
    setActiveTab(event.target.value);
  };




  return (
    <>
      <section className="section dashboard">
        <div className="row">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-xxl-4 col-md-4">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <h5 className="card-title">Active packages</h5>
                    <div className="d-flex align-items-end justify-content-between pt-4">
                      <div className="">
                        <h6>{dashboard?.activePackage}</h6>
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-4 col-md-4">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <h5 className="card-title">Active services</h5>
                    <div className="d-flex align-items-end justify-content-between pt-4">
                      <div className="">
                        <h6>{dashboard?.activeService}</h6>
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Revenue Card */}
              {/* Customers Card */}
              <div className="col-xxl-4 col-md-4">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <h5 className="card-title">Active charge basis</h5>
                    <div className="d-flex align-items-end justify-content-between pt-4">
                      <div className="">
                        <h6>{dashboard?.activeChargeBasis}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Customers Card */}

            </div>
          </div>
          {/* End Left side columns */}

        </div>
      </section>
      <div className="filter-select mb-3 select_tab">
        <div className=" d-flex">
          <select onChange={handleTabChange} value={activeTab} className="form-select">
            <option value="current-month">Current Month</option>
            <option value="prev-month">Previous Month</option>
            <option value="current-quarter">Current Quarter</option>
            <option value="previous-quarter">Previous Quarter</option>
            <option value="current-calender-quarter">Current Calendar Year</option>
            <option value="prev-calender-year">Previous Calendar Year</option>
            <option value="custom-date">Custom Date</option>
          </select>
        </div>

        {activeTab === "custom-date" && (
          <div className=" d-flex gap-2 mt-2 mb-3">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DateRangePicker"]}>
                <DatePicker.RangePicker
                  value={range}
                  onChange={setRange}
                  placeholder={['Start Date', 'End Date']}
                  format="DD/MM/YYYY"
                  className=""
                />
                {/* <DateRangePicker
                  localeText={{ start: "From", end: "To" }}
                  value={dateRange}
                  onChange={(newValue) => {
                    const formattedStartDate = newValue[0] ? dayjs(newValue[0]).format("YYYY-MM-DD") : null;
                    const formattedEndDate = newValue[1] ? dayjs(newValue[1]).format("YYYY-MM-DD") : null;

                    setStartDate(formattedStartDate);
                    setEndDate(formattedEndDate);
                    setDateRange(newValue);
                  }}
                /> */}
              </DemoContainer>
            </LocalizationProvider>
          </div>
        )}

      </div>

      <div id="my_content">
        <div className="col-md-12">
          <div>
            <section className="section dashboard">
              <div className="row">
                {/* Left side columns */}
                <div className="col-lg-7">
                  <div className="row">
                    {/* Sales Card */}
                    <div className="col-xxl-6 col-md-6">
                      <div className="card info-card sales-card">
                        <div className="card-body">
                          <h5 className="card-title">No. of packages sold</h5>
                          <div className="d-flex align-items-end justify-content-between ">
                            <div className="">
                              <h6>{dashboard?.packageSold || 0}</h6>

                              {activeTab != "custom-date" && <span className="filter-text">
                                Last month: {dashboard?.packageSoldLast || 0}
                              </span>}
                            </div>
                            <div>
                              {activeTab != "custom-date" && <div className="small">
                                <i className={`fs-5 me-1 ${dashboard?.packageSold > dashboard?.packageSoldLast
                                  ? "ri-arrow-up-circle-fill text-success"
                                  : dashboard?.packageSold < dashboard?.packageSoldLast
                                    ? "ri-arrow-down-circle-fill text-danger"
                                    : "text-secondary"
                                  }`}></i>

                                {dashboard?.packageSoldLast && dashboard?.packageSoldLast !== 0
                                  ? (
                                    ((dashboard?.packageSold - dashboard?.packageSoldLast) / dashboard?.packageSoldLast) * 100
                                  ).toFixed(2)
                                  : 0}%
                              </div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Sales Card */}
                    {/* Revenue Card */}
                    <div className="col-xxl-6 col-md-6">
                      <div className="card info-card sales-card">
                        <div className="card-body">
                          <h5 className="card-title">No of services sold</h5>
                          <div className="d-flex align-items-end justify-content-between ">
                            <div className="">
                              <h6>{dashboard?.serviceSold || 0}</h6>

                              {activeTab != "custom-date" && <span className="filter-text">
                                Last month: {dashboard?.serviceSoldLast || 0}
                              </span>}
                            </div>
                            <div>
                              {activeTab != "custom-date" && <div className="small">
                                <i className={`fs-5 me-1 ${dashboard?.serviceSold > dashboard?.serviceSoldLast
                                  ? "ri-arrow-up-circle-fill text-success"
                                  : dashboard?.serviceSold < dashboard?.serviceSoldLast
                                    ? "ri-arrow-down-circle-fill text-danger"
                                    : "text-secondary"
                                  }`}></i>

                                {dashboard?.serviceSoldLast && dashboard?.serviceSoldLast !== 0
                                  ? (
                                    ((dashboard?.serviceSold - dashboard?.serviceSoldLast) / dashboard?.serviceSoldLast) * 100
                                  ).toFixed(2)
                                  : 0}%
                              </div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Revenue Card */}


                  </div>
                </div>
                {/* End Left side columns */}

              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  )
}

export default PricingDashboard